<template>
  <div class="blog-tag-clound">
    <v-row>
      <v-spacer></v-spacer>
      <v-col :md="2">
        <v-btn class="ma-2" tile outlined color="#4caf50" @click="cloundShow = true">云  图 </v-btn>
        <v-btn class="ma-2" tile outlined color="#4caf50" @click="cloundShow = false">关系图</v-btn>
      </v-col>
    </v-row>
    <v-row class="blog-tag-row">
      <v-col v-if="cloundShow" class="md-5">
        <tag-cloud
          :data="articleTag"
          :radius="radius"
          :maxFont="maxFont"
          @clickTag="clickTagItem">
        </tag-cloud>
      </v-col>
      <v-col v-else>
        <tags-diagram :width="'100%'" :height="'100%'"></tags-diagram>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NOTES from '@/config/articles/article_tags.js'
import ROUNTER_RELATION from '@/config/router-relation.js'
import tagsDiagram from '@/components/echartsGraph/tagsDiagram.vue'

export default {
  components: {
    tagsDiagram
  },
  data () {
    return {
      maxFont:80,
      radius:600,
      cloundShow:true,
      articleTag:NOTES,
      relation:ROUNTER_RELATION
    }
  },
  methods: {
    clickTagItem (tag) {
      let name = tag.name;
      let relation = this.relation;
      let link = relation[name.toLowerCase()]
      if(link){
        this.$router.push({path:'/blog/category', query:{type:link}})
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.blog-tag-clound
  width 100%
  height 100%
  background-size cover
  background linear-gradient(rgb(69, 69, 70) 0%, rgb(0, 0, 0) 100%)

.blog-tag-row
  height  95%

.md-5
  margin-top  5%
</style>